angular.module('impactx.rfx').controller('RFXRequestSupportCtrl', [
    '$scope',
    '$routeParams',
    'ToolbarService',
    'dataGen',
    'RFXBuyerService',
    '$redirect',
    'ToastService',
    '$mdDialog',
    'ConfirmationService',
    'TranslationService',
    '$route',
    'RedirectAndSaveService',
    'RFQSearchService',
    '$location',
    '$timeout',
    RFXRequestSupportController
]);

function RFXRequestSupportController($scope, $routeParams, ToolbarService, dataGen, RFXBuyerService, $redirect, ToastService,
                                     $mdDialog, ConfirmationService, TranslationService, $route, RedirectAndSaveService, RFQSearchService,
                                     $location, $timeout) {
    var self = this;
    self.id = $routeParams.rfqhId || 0;
    self.rfqcId = 0;
    self.selectedPositions = [];
    self.previousDeleted = [];
    self.positionDialIsOpen = false;
    self.supplierSelectionIsOpen = false;
    self.requestInProgress = false;
    self.publicationMinDate = new Date();
    self.weightingTotal = 0;
    self.changedWeight = false;
    self.lastAnswerDateTimeMinDate = new Date(self.publicationMinDate);
    self.sendErrorList = [];

    self.rfqcId = $routeParams.rfqcId || 0;
    self.preselectSupplierId = $routeParams.supplierId || 0;
    self.tenderId = $routeParams.tenderId || 0;
    self.lotId = $routeParams.lotId || 0;

    self.hideSend = true;

    function getData() {
        var data = RFQSearchService.getDialogData();

        if ($routeParams.productIdToAdd < 0 && data && data.data) {
            self.data = data.data;
            self.trns = data.trns;
            self.hideSend = self.data.readOnlyDialog || !self.data.isSupportingUser;
            defineButtons();
        }
        else if ($routeParams.productIdToAdd > 0 && data && data.data) {
            self.data = data.data;
            self.trns = data.trns;
            self.hideSend = self.data.readOnlyDialog || !self.data.isSupportingUser;
            RFXBuyerService.getItemData(self.id, self.rfqsId, $routeParams.productIdToAdd, 0, false, decodeURIComponent($routeParams.amountToAdd)).then(function (item) {
                self.pushItem(item);
                defineButtons();
            }, defineButtons);
        }
        else {
            dataGen.getData(self, {rfqhId: self.id}, '/rfx/support/request/view').then(function () {
                self.hideSend = self.data.readOnlyDialog || !self.data.isSupportingUser;
                self.trns.required = TranslationService.get("required");
                defineButtons();
                adjustDates();
                $timeout(function () {
                    self.checkWeights(false, self.data.items);
                })
            });
        }
    }

    function adjustDates() {
        $scope.setLastAnswerDateTimeMinDate(self.data.publicationDate);
    }

    $scope.setLastAnswerDateTimeMinDate = function (publicationDate) {
        self.lastAnswerDateTimeMinDate = new Date(publicationDate.dateValue === null || isNaN(publicationDate.dateValue)? self.publicationMinDate : publicationDate.dateValue);
        self.lastAnswerDateTimeMinDate.setDate(self.lastAnswerDateTimeMinDate.getDate() + self.data.lastAnswerMinDays);
    };

    function defineButtons() {
        var buttonDefinition = [
            {
                label: TranslationService.get("back"),
                action: self.back,
                type: 'dialogaction'
            },
            {
                label: self.trns.save,
                action: self.saveData,
                type: 'dialogaction',
                condition: canSave
            },
            {
                label: self.trns.saveRequestAndBack,
                action: self.saveDataAndBack,
                type: 'dialogaction',
                condition: canSave
            },
            {
                label: self.trns.edit,
                action: self.editPosition,
                type: 'dialogaction',
                condition: canEditPosition
            },
            {
                label: self.trns.delete,
                action: self.deletePositions,
                type: 'dialogaction',
                condition: canDeletePositions
            },
            {
                label: self.trns.conversations,
                action: self.warnAndRedirectToConversations,
                type: 'dialogaction',
                condition: canViewConversations
            },
            {
                label: self.trns.changeDates,
                action: self.openEditDateDialog,
                type: 'dialogaction',
                condition: canOpenDatesDialog,
            },
            {
                label: self.trns.offers,
                linkFunction: getOfferLink,
                type: 'link',
                condition: canViewOffers,
                process: 'RFXRequestSupportView'
            },
            {
                label: self.trns.startSupport,
                action: self.startSupport,
                type: 'dialogaction',
                condition: canStartSupport
            },
            {
                label: self.trns.finishSupport,
                action: self.finishSupport,
                type: 'dialogaction',
                condition: canFinishSupport
            }
        ];
        ToolbarService.hideBackButton();
        ToolbarService.setButtons(buttonDefinition);
    }

    self.back = function () {
        $redirect.redirectTo(null, '/rfxrequestsupportlist');
    };

    function getOfferLink() {
        return "rfx/offers/support/" + self.id;
    }

    function canViewOffers() {
        return self.data.canViewOffers;
    }

    function canSave() {
        return !self.data.readOnlyDialog && self.data.isSupportingUser;
    }

    self.saveData = function () {
        return RFXBuyerService.saveDialogSupportData(self, false);
    }

    self.saveDataAndBack = function () {
        return RFXBuyerService.saveDialogSupportData(self, true);
    };

    function canFinishSupport() {
        return self.data.isSupportingUser;
    }

    function canStartSupport() {
        return self.data.requestedSupport && !self.data.isSupportingUser;
    }

    self.finishSupport = function () {
        return dataGen.postAsForm({}, {rfqhId: self.id}, "/rfx/support/request/finishsupport").then(function (data) {
            if(data.data && data.data.message) {
                ToastService.openStandardToast(data.data.message);
            }
            $redirect.redirectTo(null, "/rfxrequestsupportlist");
        });
    }

    self.startSupport = function () {
        return dataGen.postAsForm({}, {rfqhId: self.id}, "/rfx/support/request/startsupport").then(function (data) {
            if(data.data && data.data.message) {
                ToastService.openStandardToast(data.data.message);
            }
            $redirect.reload();
        });
    }

    self.openAddSupplierListDialog = function (event, afterSend) {
        $mdDialog.show({
            templateUrl: "modules/rfx/templates/rfx-add-supplier-list-dialog.html",
            controller: "RFXAddSupplierListCtrl",
            controllerAs: "ctrl",
            targetEvent: event,
            parent: angular.element(document.body),
            clickOutsideToClose: false,
            locals: {
                config: {
                    rfqhId: self.id,
                    rfqcId: self.data.rfqcId,
                    selected: self.data.suppliers,
                    afterSend: afterSend,
                    tenderId: self.tenderId,
                    lotId: self.lotId,
                    useBuyerContext: true
                }
            }
        }).then(function (selection) {
            if(selection)
            {
                $scope.dialogData.$setDirty();
                self.data.suppliers.push(...selection)
            }
        }, angular.noop);
    };

    self.canDeleteSupplier = function (supplier)
    {
        return canSave() && !supplier.readOnly;
    };

    self.deleteSupplierDialog = function (event, supplier) {
        if (self.data.showSupplierDeleteConfirmationDialog) {
            const question = self.trns.deleteSupplierQuestion.replace('^0', supplier.value)
            ConfirmationService.showConfirmationDialog(function () {
                    return self.deleteSupplier(supplier);
                },
                event, TranslationService.get('confirmDelete'),
                TranslationService.get('delete'), TranslationService.get('abort'), question);
        }
        else {
            self.deleteSupplier(supplier);
        }
    };

    self.deleteSupplier = function (supplier) {
        var index = self.data.suppliers.indexOf(supplier);
        if (index >= 0) {
            self.data.suppliers.splice(index, 1);
        }
        $scope.dialogData.$setDirty();
    };

    self.sendData = function (event) {
        if (self.data.useTextCustomization) {
            var tempScope = {};
            RFXBuyerService.saveData(tempScope, self).then(function () {
                var rfghId = self.id > 0 ? self.id : tempScope.data.rfqhId;
                self.data.id = rfghId;
                RFXBuyerService.showTextCustomization(event, rfghId, RFXBuyerService.STATUS.READY_FOR_PUBLISH).then(function (result) {
                    if (result && result.send) {
                        RFXBuyerService.sendAfterTextCustomization(self);
                    }
                    else {
                        $route.reload();
                    }
                }, function () {
                    $route.reload();
                });
            });
        }
        else {
            RFXBuyerService.sendDialogData(self, true);
        }
    };

    function canOpenDatesDialog() {
        return self.data.readOnlyDialog && self.data.isSupportingUser && self.data.canChangeDates && self.data.isPublished &&
            (!self.data.hasCascade || self.data.cascadeOnFirstSupplier);
    }

    self.openEditDateDialog = function (event) {
        $mdDialog.show({
            templateUrl: "modules/rfx/templates/rfx-edit-date-dialog.html",
            controller: "RFXEditDateCtrl",
            controllerAs: "rfxEditDateCtrl",
            targetEvent: event,
            parent: angular.element(document.body),
            clickOutsideToClose: false,
            locals: {
                rfqhId: self.id,
                reload: true
            }
        });
    };

    self.saveUsers = function () {
        if (self.data.id > 0) {
            return dataGen.postAsForm({}, {formData: self.data}, '/rfx/buyer/saveusers').then(function (data) {
                if (data && data.data && data.data.removedOwnUser) {
                    $redirect.redirectTo(null, "/rfxrequestsupportlist");
                }
                ToastService.openStandardToast(TranslationService.get('saveSuccess'));
            })
        }
    };

    self.allowConversations = function () {
        return impactX.isDefined(self, 'data.allowConversations');
    };

    function canViewConversations() {
        return self.allowConversations();
    }

    self.warnAndRedirectToConversations = function (event) {
        if ($scope.dialogData.$dirty) {
            if (canSave()) {
                RedirectAndSaveService.showRedirectAndSaveDialog(self.saveAndRedirectToConversations, self.redirectToConversations, event,
                    self.trns.changedDataQuestion, TranslationService.get("save"), TranslationService.get("abort"), self.trns.noSave,
                    false);
            }
            else {
                self.redirectToConversations();
            }
        }
        else {
            self.redirectToConversations();
        }
    };

    self.saveAndRedirectToConversations = function () {
        RFXBuyerService.saveAndRedirectToConversations(self);
    };

    self.redirectToConversations = function() {
        $redirect.redirectTo(null, 'rfxthread/support/' + self.id);
    };

    self.canAddProduct = function () {
        return impactX.isDefined(self, 'data.allowAddProductBuyer');
    };

    self.openProductSelection = function (event) {
        var params = {id: $routeParams.rfqhId};
        params.data = self.data;
        params.trns = self.trns;
        params.path = $location.path();
        params.rfqcId = self.data.rfqcId;
        params.supplierId = self.preselectSupplierId
        params.tenderId = self.tenderId;
        params.lotId = self.lotId;
        if ($routeParams.amountToAdd) {
            params.path = params.path.substring(0, params.path.lastIndexOf("/"));
        }
        if ($routeParams.productIdToAdd) {
            params.path = params.path.substring(0, params.path.lastIndexOf("/"));
        }
        if (!$routeParams.rfqcId) {
            params.path = params.path + "/0";
        }
        if (!$routeParams.supplierId) {
            params.path = params.path + "/0";
        }
        if (!$routeParams.tenderId) {
            params.path = params.path + "/0";
        }
        if (!$routeParams.lotId) {
            params.path = params.path + "/0";
        }
        RFQSearchService.activateRFQHSearch(params);
    };

    self.canAddQuestion = function () {
        return impactX.isDefined(self, 'data.allowAddQuestionBuyer');
    };

    self.canAddInternal = function () {
        return impactX.isDefined(self, 'data.allowAddInternalBuyer');
    };

    self.canAddSmartform = function () {
        return impactX.isDefined(self, 'data.allowAddSmartformBuyer');
    };

    self.addQuestion = function (event) {
        var newItem = {isInformation: true};
        RFXBuyerService.showEditPositionDialog(event, self.id, newItem, self.trns).then(function (item) {
            self.pushItem(item);
        })
    };

    self.addInternal = function (event) {
        var newItem = {isInternal: true};
        RFXBuyerService.showEditPositionDialog(event, self.id, newItem, self.trns).then(function (item) {
            self.pushItem(item);
        })
    };

    self.canAddFreeFormItem = function () {
        return impactX.isDefined(self, 'data.allowAddFreeformBuyer');
    };

    self.addFreeformItem = function (event) {
        RFXBuyerService.showEditPositionDialog(event, self.id, {isFreeForm: true}, self.trns).then(function (item) {
            self.pushItem(item);
        })
    };

    self.addSmartFormItem = function (event) {
        RFXBuyerService.openSmartFormItemDialog(event, self.data.smartFormTemplates, self.id, {}, self.trns).then(function (item) {
            item.isInformation = self.isInformation(item);
            self.pushItem(item);
        })
    };

    self.isInformation = function (item) {
        var policy;
        if (item.smartForm) {
            policy = self.getSmartFormPolicy(item.smartForm.identifier);
        }
        return item.isInformation || (policy && policy.isInformation);
    };

    self.pushItem = function (item) {
        $scope.dialogData.$setDirty();
        self.data.items.push(item);
        if (!self.changedWeight) {
            self.normalizeWeights();
        }
    };

    self.getSmartFormPolicy = function (id) {
        var policies = self.data.smartFormPolicies;
        if (typeof id === 'string') {
            for (var key in policies) {
                if (policies.hasOwnProperty(key) &&
                    policies[key].identifier === id) {
                    return policies[key];
                }
            }
        }
        else if (typeof id === 'number' && !isNaN(id)) {
            return policies[id];
        }
    };

    self.selectPosition = function (position) {
        var index = self.selectedPositions.indexOf(position);
        if (index < 0) {
            self.selectedPositions.push(position);
        }
        else {
            self.selectedPositions.splice(index, 1);
        }
    };

    self.isSelected = function (item) {
        return self.selectedPositions.indexOf(item) >= 0;
    };

    self.editPosition = function (event) {
        if (self.selectedPositions.length == 1) {
            $scope.dialogData.$setDirty();
            var selectedItem = self.selectedPositions[0];
            RFXBuyerService.showEditPositionDialog(event, self.id, selectedItem, self.trns, self.data.smartFormTemplates).then(function (item) {
                item.isInformation = self.isInformation(item);
                var index = self.data.items.indexOf(selectedItem);
                if (index >= 0) {
                    self.data.items[index] = item;
                }
            });

            self.selectedPositions = [];
        }
    };

    self.deletePositions = function () {
        $scope.dialogData.$setDirty();
        self.previousDeleted = [];
        angular.forEach(self.selectedPositions, function (entry) {
            var index = self.data.items.indexOf(entry);
            if (index >= 0) {
                self.previousDeleted.push(entry);
                self.data.items.splice(index, 1);
            }
        });
        self.selectedPositions = [];

        RFXBuyerService.showRevertDeletionToast(revertDeletion);
    };

    function revertDeletion() {
        angular.forEach(self.previousDeleted, function (item) {
            self.pushItem(item);
        })
    }

    self.normalizeWeights = function () {
        if (self.data.items && self.data.items.length > 0) {
            // total is 100% with 3 decimals allowed => integer is 100000
            // divide by number of items and truncate any decimals
            var size = self.data.items.length;
            var decimalFactor = 1000;
            var total = 100 * decimalFactor;
            var normalized = Math.floor(total / size);
            var highestWeightItem;
            var highestWeight = 0
            for (var i = 0; i < size; i++) {
                var item = self.data.items[i];
                if (!highestWeightItem || highestWeight < item.weightValuePartPublic.value) {
                    highestWeightItem = item;
                    highestWeight = item.weightValuePartPublic.value;
                }
                item.weightValuePartPublic.value = normalized / decimalFactor;
            }
            highestWeightItem.weightValuePartPublic.value = (normalized + (total - (normalized * size))) / decimalFactor;
            self.checkWeights(false, self.data.items);
        }
    }

    self.checkWeights = function (changed, items) {
        if (self.data.allowPositionWeighting)
        {
            if (items && items.length > 1)
            {
                var total = 0;
                for (var i = 0; i < items.length; i++)
                {
                    total += Number(items[i].weightValuePartPublic.value);
                }
                self.weightingTotal = total;
                $scope.dialogData['weighting'].$setValidity("invalidFactors", total === 100);
                self.changedWeight = changed;
            }
            else
            {
                self.weightingTotal = 0;
                $scope.dialogData['weighting'].$setValidity("invalidFactors", true);
            }
        }
    }

    self.getCascadeTimelineCSS = function(index) {
        if(self.data.cascadeTimeline.entries.length === 1) {
            return 'table-timeline-line-single';
        }
        else if(index === 0) {
            return 'table-timeline-line-first';
        }
        else if(index === self.data.cascadeTimeline.entries.length - 1) {
            return 'table-timeline-line-last';
        }
        else {
            return 'table-timeline-line';
        }
    }

    function canEditPosition() {
        return self.selectedPositions.length === 1;
    }

    function canDeletePositions() {
        return self.selectedPositions.length >= 1;
    }
    getData();
}
